import { render } from "./TextSeparator.vue?vue&type=template&id=355cd4ef&scoped=true"
import script from "./TextSeparator.vue?vue&type=script&lang=js"
export * from "./TextSeparator.vue?vue&type=script&lang=js"

import "./TextSeparator.vue?vue&type=style&index=0&id=355cd4ef&lang=scss&scoped=true"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355cd4ef"]])

export default __exports__